<img *ngIf="size=='large'" class="avatar large" [src]="avatarPicture">
<img *ngIf="size=='small'" class="avatar small" [src]="avatarPicture">

